export const ADMIN_ID = 123;